'use client';

import { useEffect, useRef } from 'react';
import { useClickStream, EventType } from '@brahma/hooks';
import { usePathname } from 'next/navigation';
import { deferToIdle } from '$lib/deferToIdle';
export default function PageVisitDataCapture({
  user
}: {
  user: any;
}) {
  const {
    trackEvent
  } = useClickStream('PageVisitDataCapture', user);
  const pathname = usePathname();
  const lastPathname = useRef<string | null>(null);
  useEffect(() => {
    if (pathname !== lastPathname.current) {
      // Defer tracking to idle time so it doesn't block hydration
      // or compete with critical rendering work
      const cancel = deferToIdle(() => {
        trackEvent({
          eventType: EventType.PAGE_VISIT,
          data: {}
        });
      });
      lastPathname.current = pathname;
      return cancel;
    }
  }, [pathname, trackEvent]);
  return null;
}